import { LoginResponseDto } from '../../lib/api';
import { Outlet, useParams, useRouteLoaderData } from 'react-router-dom';
import Content from '../../components/content';
import { Building2 } from 'lucide-react';

export function BranchLayout() {
    const params = useParams<'branchId'>();
    const session = useRouteLoaderData('root') as LoginResponseDto;
    const headerTitle = params.branchId ? session.scope?.branches.find((branch) => branch.id === params.branchId)?.name : 'Add Branch';

    return (
        <Content headerTitle={headerTitle} headerIcon={<Building2 size="15" />} backNavLink="/organization/overview">
            {{ content: <Outlet /> }}
        </Content>
    );
}
